import { Component, OnInit } from "@angular/core";
import { PollResponsesService } from "./pollresponses.service";
import { Router } from "@angular/router";

@Component({
  selector: "poll-responses",
  template: require('./pollresponses.component.html'),
  styles: [require('./pollresponses.component.scss')]
})
export class PollResponsesComponent implements OnInit {
  currentPoll: any;
  pollResponses: any[];
  responseStats: any[] = [];
  errorMessage: any;

  constructor(private service: PollResponsesService, private router: Router) {
    this.currentPoll = this.service.getCurrentPoll();
    if (!this.currentPoll) {
      this.router.navigate(["/polls"]);
    } else {
      this.getResponseStats();
    }
  }

  ngOnInit() {}

  getResponseStats() {
    let self = this;
    self.currentPoll.responseStats = [];
    this.currentPoll.content[self.currentPoll.default_lang].responses.map(
      (resp) => {
        let key = resp.value + " (" + resp.text + ")";
        let count = self.currentPoll.responses.filter((r) => {
          return r.response === resp.value;
        }).length;
        let percent = (count / (self.currentPoll.responses.length || 1)) * 100;
        self.currentPoll.responseStats.push({
          key: key,
          count: count,
          percent: percent
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pollresponses/pollresponses.component.ts